import React, { useEffect, useState } from "react";
import { db, storage } from "../firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import {
  collection,
  getDocs,
  deleteDoc,
  doc,
  addDoc,
  updateDoc,
  serverTimestamp,
  query,
  orderBy,
} from "firebase/firestore";
import { toast } from "react-hot-toast";
import "../screenstyles/OffersPoint.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrash,
  faSearch,
  faAdd,
  faKey,
  faPowerOff,
} from "@fortawesome/free-solid-svg-icons";

import {
  Modal,
  Box,
  Typography,
  Button,
  TextField,
  Switch,
  FormControlLabel,
} from "@mui/material";

interface LocalizedText {
  ar: string;
  en: string;
  ku: string;
}

interface OfferPoint {
  id: string;
  offerName: LocalizedText;
  pointsValue: string | number;
  balanceValue: string | number;
  companyName: string;
  expiryDate: string;
  offerDescription: LocalizedText;
  isActive: boolean;
  imageUrl?: string;
  createdAt?: any;
}

interface SerialItem {
  id: string;
  serialNumber: string;
  isUsed: boolean;
  usedBy?: string | null;
  usedAt?: any;
}

const OffersPoint: React.FC = () => {
  const [offers, setOffers] = useState<OfferPoint[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [searchQuery, setSearchQuery] = useState<string>("");

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedOfferId, setSelectedOfferId] = useState<string | null>(null);

  const [offerModalOpen, setOfferModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const [serialModalOpen, setSerialModalOpen] = useState(false);
  const [serialsText, setSerialsText] = useState("");
  const [offerSerials, setOfferSerials] = useState<SerialItem[]>([]);
const [selectedImage, setSelectedImage] = useState<File | null>(null);
const [imagePreview, setImagePreview] = useState<string>("");
 const [formData, setFormData] = useState({
  offerName: {
    ar: "",
    en: "",
    ku: "",
  },
  pointsValue: "",
  balanceValue: "",
  companyName: "",
  expiryDate: "",
  offerDescription: {
    ar: "",
    en: "",
    ku: "",
  },
  isActive: true,
  imageUrl: "",
});

  const fetchOffers = async () => {
    setLoading(true);

    try {
      const offersCollection = collection(db, "OffersPoint");
      const offerDocs = await getDocs(offersCollection);

      const fetchedOffers: OfferPoint[] = [];

      offerDocs.forEach((docSnap) => {
        fetchedOffers.push({
          id: docSnap.id,
          ...(docSnap.data() as Omit<OfferPoint, "id">),
        });
      });

      setOffers(fetchedOffers);
    } catch (error) {
      console.error("Error fetching offers:", error);
      toast.error("حدث خطأ أثناء جلب العروض");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOffers();
  }, []);

  const q = searchQuery.trim().toLowerCase();

 const filteredOffers = offers.filter((offer) => {
  if (!q) return true;

  const offerNameAr = (offer.offerName?.ar ?? "").toLowerCase();
  const offerNameEn = (offer.offerName?.en ?? "").toLowerCase();
  const offerNameKu = (offer.offerName?.ku ?? "").toLowerCase();

  const descriptionAr = (offer.offerDescription?.ar ?? "").toLowerCase();
  const descriptionEn = (offer.offerDescription?.en ?? "").toLowerCase();
  const descriptionKu = (offer.offerDescription?.ku ?? "").toLowerCase();

  const companyName = (offer.companyName ?? "").toLowerCase();
  const pointsValue = String(offer.pointsValue ?? "").toLowerCase();
  const balanceValue = String(offer.balanceValue ?? "").toLowerCase();
  const expiryDate = String(offer.expiryDate ?? "").toLowerCase();

  return (
    offerNameAr.includes(q) ||
    offerNameEn.includes(q) ||
    offerNameKu.includes(q) ||
    descriptionAr.includes(q) ||
    descriptionEn.includes(q) ||
    descriptionKu.includes(q) ||
    companyName.includes(q) ||
    pointsValue.includes(q) ||
    balanceValue.includes(q) ||
    expiryDate.includes(q)
  );
});  



 const resetForm = () => {
 setFormData({
  offerName: {
    ar: "",
    en: "",
    ku: "",
  },
  pointsValue: "",
  balanceValue: "",
  companyName: "",
  expiryDate: "",
  offerDescription: {
    ar: "",
    en: "",
    ku: "",
  },
  isActive: true,
  imageUrl: "",
});

  setSelectedImage(null);
  setImagePreview("");
};

  const openAddOfferModal = () => {
    resetForm();
    setIsEditMode(false);
    setSelectedOfferId(null);
    setOfferModalOpen(true);
  };

  const openEditOfferModal = (offer: OfferPoint) => {
    setSelectedOfferId(offer.id);
    setIsEditMode(true);

  setFormData({
offerName: {
  ar: offer.offerName?.ar || "",
  en: offer.offerName?.en || "",
  ku: offer.offerName?.ku || "",
},
offerDescription: {
  ar: offer.offerDescription?.ar || "",
  en: offer.offerDescription?.en || "",
  ku: offer.offerDescription?.ku || "",
},  pointsValue: String(offer.pointsValue || ""),
  balanceValue: String(offer.balanceValue || ""),
  companyName: offer.companyName || "",
  expiryDate: offer.expiryDate || "",
  isActive: offer.isActive ?? true,
  imageUrl: offer.imageUrl || "",
  
}
);


setSelectedImage(null);
setImagePreview(offer.imageUrl || "");
setOfferModalOpen(true);
};

const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const file = e.target.files?.[0];

  if (!file) return;

  if (!file.type.startsWith("image/")) {
    toast.error("يرجى اختيار ملف صورة فقط");
    return;
  }

  setSelectedImage(file);
  setImagePreview(URL.createObjectURL(file));
};

  const handleSaveOffer = async () => {
  if (!formData.offerName.ar.trim()) {
  toast.error("يرجى إدخال اسم العرض باللغة العربية");
  return;
}

if (!formData.offerName.en.trim()) {
  toast.error("يرجى إدخال اسم العرض باللغة الإنجليزية");
  return;
}

if (!formData.offerName.ku.trim()) {
  toast.error("يرجى إدخال اسم العرض باللغة الكردية");
  return;
}

    if (!formData.pointsValue.trim()) {
      toast.error("يرجى إدخال قيمة النقاط");
      return;
    }

    if (!formData.balanceValue.trim()) {
      toast.error("يرجى إدخال قيمة الرصيد");
      return;
    }

    if (!formData.companyName.trim()) {
      toast.error("يرجى إدخال اسم الشركة");
      return;
    }

    try {
    let imageUrl = formData.imageUrl;

if (selectedImage) {
  const imageRef = ref(
    storage,
    `OffersPointImages/${Date.now()}_${selectedImage.name}`
  );

  await uploadBytes(imageRef, selectedImage);
  imageUrl = await getDownloadURL(imageRef);
}

const dataToSave = {
  offerName: formData.offerName,
  pointsValue: Number(formData.pointsValue),
  balanceValue: Number(formData.balanceValue),
  companyName: formData.companyName,
  expiryDate: formData.expiryDate,
  offerDescription: formData.offerDescription,
  isActive: formData.isActive,
  imageUrl: imageUrl,
  updatedAt: serverTimestamp(),
};

      if (isEditMode && selectedOfferId) {
        await updateDoc(doc(db, "OffersPoint", selectedOfferId), dataToSave);
        toast.success("تم تعديل العرض بنجاح");
      } else {
        await addDoc(collection(db, "OffersPoint"), {
          ...dataToSave,
          createdAt: serverTimestamp(),
        });
        toast.success("تم إضافة العرض بنجاح");
      }

      setOfferModalOpen(false);
      resetForm();
      fetchOffers();
    } catch (error) {
      console.error("Error saving offer:", error);
      toast.error("حدث خطأ أثناء حفظ العرض");
    }
  };

  const handleToggleActive = async (offer: OfferPoint) => {
    try {
      await updateDoc(doc(db, "OffersPoint", offer.id), {
        isActive: !offer.isActive,
        updatedAt: serverTimestamp(),
      });

      toast.success(
        !offer.isActive ? "تم تفعيل العرض" : "تم إيقاف العرض"
      );

      fetchOffers();
    } catch (error) {
      console.error("Error updating offer status:", error);
      toast.error("حدث خطأ أثناء تحديث حالة العرض");
    }
  };

  const openDeleteModal = (id: string) => {
    setSelectedOfferId(id);
    setDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setSelectedOfferId(null);
    setDeleteModalOpen(false);
  };

  const handleDelete = async () => {
    if (!selectedOfferId) return;

    try {
      await deleteDoc(doc(db, "OffersPoint", selectedOfferId));

      toast.success("تم حذف العرض بنجاح");
      closeDeleteModal();
      fetchOffers();
    } catch (error) {
      console.error("Error deleting offer:", error);
      toast.error("حدث خطأ أثناء حذف العرض");
    }
  };

  const fetchOfferSerials = async (offerId: string) => {
    try {
      const serialsRef = collection(db, "OffersPoint", offerId, "serials");
      const q = query(serialsRef, orderBy("createdAt", "desc"));
      const serialDocs = await getDocs(q);

      const fetchedSerials: SerialItem[] = [];

      serialDocs.forEach((docSnap) => {
        fetchedSerials.push({
          id: docSnap.id,
          ...(docSnap.data() as Omit<SerialItem, "id">),
        });
      });

      setOfferSerials(fetchedSerials);
    } catch (error) {
      console.error("Error fetching serials:", error);
      toast.error("حدث خطأ أثناء جلب أرقام الرصيد");
    }
  };

  const openSerialModal = async (offerId: string) => {
    setSelectedOfferId(offerId);
    setSerialsText("");
    setSerialModalOpen(true);
    await fetchOfferSerials(offerId);
  };

  const handleAddSerials = async () => {
    if (!selectedOfferId) return;

    const serials = serialsText
      .split(/\n|,/)
      .map((x) => x.trim())
      .filter((x) => x.length > 0);

    if (serials.length === 0) {
      toast.error("يرجى إدخال رقم تسلسلي واحد على الأقل");
      return;
    }

    const uniqueSerials = Array.from(new Set(serials));

    try {
      for (const serial of uniqueSerials) {
        await addDoc(
          collection(db, "OffersPoint", selectedOfferId, "serials"),
          {
            serialNumber: serial,
            isUsed: false,
            usedBy: null,
            usedAt: null,
            createdAt: serverTimestamp(),
          }
        );
      }

      toast.success(`تم إضافة ${uniqueSerials.length} رقم رصيد`);
      setSerialsText("");
      fetchOfferSerials(selectedOfferId);
    } catch (error) {
      console.error("Error adding serials:", error);
      toast.error("حدث خطأ أثناء إضافة الأرقام التسلسلية");
    }
  };

  const handleDeleteSerial = async (serialId: string) => {
    if (!selectedOfferId) return;

    try {
      await deleteDoc(
        doc(db, "OffersPoint", selectedOfferId, "serials", serialId)
      );

      toast.success("تم حذف الرقم التسلسلي");
      fetchOfferSerials(selectedOfferId);
    } catch (error) {
      console.error("Error deleting serial:", error);
      toast.error("حدث خطأ أثناء حذف الرقم التسلسلي");
    }
  };

return (
  <div className="offers-point-page" dir="rtl">
    <div className="offers-point-header">
  <h1 className="offers-point-title">عروض استبدال النقاط</h1>

  <div className="offers-point-search-box">
    <FontAwesomeIcon icon={faSearch} className="offers-point-search-icon" />
    <input
      type="text"
      placeholder="البحث في العروض..."
      className="offers-point-search-input"
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
    />
  </div>

  <button
    type="button"
    className="offers-point-header-action-btn"
    onClick={openAddOfferModal}
    title="إضافة عرض جديد"
  >
    <FontAwesomeIcon icon={faAdd} />
    <span>إضافة عرض</span>
  </button>
</div>

    {loading ? (
  <div className="offers-point-loading">جاري تحميل البيانات...</div>
) : (
  <div className="offers-point-table-container">
    <table className="offers-point-table">
           <thead>
              <tr>
                <th>#</th>
                <th className="price-column">الصورة</th>
                <th className="price-column">اسم العرض</th>
                <th className="price-column">الشركة</th>
                <th className="price-column">قيمة النقاط</th>
                <th className="price-column">قيمة الرصيد</th>
                <th className="price-column">تاريخ النفاذ</th>
                <th className="price-column">الحالة</th>
                <th className="price-column">الوصف</th>
                <th className="price-column">الإجراءات</th>
              </tr>
            </thead>

            <tbody>
              {filteredOffers.length > 0 ? (
                filteredOffers.map((offer, index) => (
                  <tr key={offer.id}>
                    <td>{index + 1}</td>

<td>
  {offer.imageUrl ? (
    <img
      src={offer.imageUrl}
      alt={offer.offerName?.ar || "صورة العرض"}
      className="offers-point-image"
    />
  ) : (
    <div className="offers-point-empty-image">لا توجد صورة</div>
  )}
</td>
           <td>
  <div className="offers-point-localized-block">
    <div><strong>عربي:</strong> {offer.offerName?.ar}</div>
    <div dir="ltr"><strong>EN:</strong> {offer.offerName?.en}</div>
    <div><strong>کوردی:</strong> {offer.offerName?.ku}</div>
  </div>
</td>
                   <td className="offers-point-cell-text">{offer.companyName}</td>
<td className="offers-point-cell-text">{offer.pointsValue}</td>
<td className="offers-point-cell-text">{offer.balanceValue}</td>
<td className="offers-point-date-cell">{offer.expiryDate}</td>

                    <td>
  <span className={offer.isActive ? "offers-point-status-active" : "offers-point-status-inactive"}>
    {offer.isActive ? "متاح" : "غير متاح"}
  </span>
</td>

                   <td>
  <div className="offers-point-description-block">
    <div><strong>عربي:</strong> {offer.offerDescription?.ar}</div>
    <div dir="ltr"><strong>EN:</strong> {offer.offerDescription?.en}</div>
    <div><strong>کوردی:</strong> {offer.offerDescription?.ku}</div>
  </div>
</td>

                    <td>
  <div className="offers-point-actions">
    <button
      type="button"
      className="offers-point-action-btn offers-point-edit-btn"
      onClick={() => openEditOfferModal(offer)}
      title="تعديل العرض"
    >
      <FontAwesomeIcon icon={faEdit} />
    </button>

    <button
      type="button"
      className="offers-point-action-btn offers-point-serial-btn"
      onClick={() => openSerialModal(offer.id)}
      title="إضافة أرقام الرصيد"
    >
      <FontAwesomeIcon icon={faKey} />
    </button>

    <button
      type="button"
      className={
        offer.isActive
          ? "offers-point-action-btn offers-point-power-btn active"
          : "offers-point-action-btn offers-point-power-btn"
      }
      onClick={() => handleToggleActive(offer)}
      title={offer.isActive ? "إيقاف العرض" : "تفعيل العرض"}
    >
      <FontAwesomeIcon icon={faPowerOff} />
    </button>

    <button
      type="button"
      className="offers-point-action-btn offers-point-delete-btn"
      onClick={() => openDeleteModal(offer.id)}
      title="حذف العرض"
    >
      <FontAwesomeIcon icon={faTrash} />
    </button>
  </div>
</td>
                  </tr>
                ))
              ) : (
                <tr>
                 <td colSpan={10}>
  <div className="offers-point-empty-state">لا توجد عروض</div>
</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* مودال إضافة / تعديل العرض */}
      <Modal open={offerModalOpen} onClose={() => setOfferModalOpen(false)}>
       <Box
  sx={{
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: 1100,
    maxHeight: "90vh",
    overflowY: "auto",
    bgcolor: "white",
    borderRadius: "10px",
    boxShadow: 24,
    p: 3,
    direction: "rtl",
  }}
>
          <Typography
            variant="h6"
            sx={{
              textAlign: "center",
              mb: 2,
              fontFamily: "Tajawal, sans-serif",
              fontWeight: "bold",
            }}
          >
            {isEditMode ? "تعديل العرض" : "إضافة عرض جديد"}
          </Typography>


     <Box
  sx={{
    display: "grid",
    gridTemplateColumns: {
      xs: "1fr",
      md: "repeat(2, 1fr)",
      lg: "repeat(3, 1fr)",
    },
    gap: 2,
    alignItems: "start",
  }}
>
  <TextField
    fullWidth
    label="اسم العرض - عربي"
    value={formData.offerName.ar}
    onChange={(e) =>
      setFormData({
        ...formData,
        offerName: {
          ...formData.offerName,
          ar: e.target.value,
        },
      })
    }
  />

  <TextField
    fullWidth
    label="Offer Name - English"
    dir="ltr"
    value={formData.offerName.en}
    onChange={(e) =>
      setFormData({
        ...formData,
        offerName: {
          ...formData.offerName,
          en: e.target.value,
        },
      })
    }
  />

  <TextField
    fullWidth
    label="ناوی ئۆفەر - کوردی"
    value={formData.offerName.ku}
    onChange={(e) =>
      setFormData({
        ...formData,
        offerName: {
          ...formData.offerName,
          ku: e.target.value,
        },
      })
    }
  />

  <TextField
    fullWidth
    label="الشركة"
    placeholder="مثال: آسياسيل أو زين العراق"
    value={formData.companyName}
    onChange={(e) =>
      setFormData({ ...formData, companyName: e.target.value })
    }
  />

  <TextField
    fullWidth
    label="قيمة النقاط"
    type="number"
    value={formData.pointsValue}
    onChange={(e) =>
      setFormData({ ...formData, pointsValue: e.target.value })
    }
  />

  <TextField
    fullWidth
    label="قيمة الرصيد"
    type="number"
    placeholder="مثال: 10000"
    value={formData.balanceValue}
    onChange={(e) =>
      setFormData({ ...formData, balanceValue: e.target.value })
    }
  />

  <TextField
    fullWidth
    label="تاريخ نفاذ العرض"
    type="date"
    InputLabelProps={{ shrink: true }}
    value={formData.expiryDate}
    onChange={(e) =>
      setFormData({ ...formData, expiryDate: e.target.value })
    }
  />

  <Box>
    <Typography
      sx={{
        mb: 1,
        fontFamily: "Tajawal, sans-serif",
        fontWeight: "bold",
      }}
    >
      صورة العرض
    </Typography>

    <Button variant="outlined" component="label" fullWidth>
      اختيار صورة العرض
      <input
        type="file"
        hidden
        accept="image/*"
        onChange={handleImageChange}
      />
    </Button>

    {imagePreview && (
      <Box sx={{ mt: 2, textAlign: "center" }}>
        <img
          src={imagePreview}
          alt="صورة العرض"
          style={{
            width: 160,
            height: 100,
            objectFit: "cover",
            borderRadius: 10,
            border: "1px solid #ddd",
          }}
        />
      </Box>
    )}
  </Box>

  <Box>
    <FormControlLabel
      control={
        <Switch
          checked={formData.isActive}
          onChange={(e) =>
            setFormData({ ...formData, isActive: e.target.checked })
          }
        />
      }
      label={formData.isActive ? "العرض متاح" : "العرض غير متاح"}
    />
  </Box>

  <TextField
    fullWidth
    label="وصف العرض - عربي"
    multiline
    rows={3}
    value={formData.offerDescription.ar}
    onChange={(e) =>
      setFormData({
        ...formData,
        offerDescription: {
          ...formData.offerDescription,
          ar: e.target.value,
        },
      })
    }
    sx={{ gridColumn: { xs: "span 1", lg: "span 1" } }}
  />

  <TextField
    fullWidth
    label="Offer Description - English"
    multiline
    rows={3}
    dir="ltr"
    value={formData.offerDescription.en}
    onChange={(e) =>
      setFormData({
        ...formData,
        offerDescription: {
          ...formData.offerDescription,
          en: e.target.value,
        },
      })
    }
    sx={{ gridColumn: { xs: "span 1", lg: "span 1" } }}
  />

  <TextField
    fullWidth
    label="وەسفی ئۆفەر - کوردی"
    multiline
    rows={3}
    value={formData.offerDescription.ku}
    onChange={(e) =>
      setFormData({
        ...formData,
        offerDescription: {
          ...formData.offerDescription,
          ku: e.target.value,
        },
      })
    }
    sx={{ gridColumn: { xs: "span 1", lg: "span 1" } }}
  />
</Box>



          <FormControlLabel
            control={
              <Switch
                checked={formData.isActive}
                onChange={(e) =>
                  setFormData({ ...formData, isActive: e.target.checked })
                }
              />
            }
            label={formData.isActive ? "العرض متاح" : "العرض غير متاح"}
          />

          <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 2 }}>
            <Button variant="contained" onClick={handleSaveOffer}>
              {isEditMode ? "حفظ التعديل" : "إضافة العرض"}
            </Button>

            <Button
              variant="outlined"
              color="secondary"
              onClick={() => setOfferModalOpen(false)}
            >
              إلغاء
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* مودال إضافة أرقام الرصيد */}
      <Modal open={serialModalOpen} onClose={() => setSerialModalOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 650,
            maxHeight: "85vh",
            overflowY: "auto",
            bgcolor: "white",
            borderRadius: "10px",
            boxShadow: 24,
            p: 3,
            direction: "rtl",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              textAlign: "center",
              mb: 2,
              fontFamily: "Tajawal, sans-serif",
              fontWeight: "bold",
            }}
          >
            إضافة أرقام تسلسلية للرصيد
          </Typography>

          <TextField
            fullWidth
            label="الأرقام التسلسلية"
            placeholder={`ضع كل رقم في سطر منفصل
مثال:
123456789
987654321
555555555`}
            multiline
            rows={6}
            value={serialsText}
            onChange={(e) => setSerialsText(e.target.value)}
          />

          <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 2 }}>
            <Button variant="contained" onClick={handleAddSerials}>
              إضافة الأرقام
            </Button>

            <Button
              variant="outlined"
              color="secondary"
              onClick={() => setSerialModalOpen(false)}
            >
              إغلاق
            </Button>
          </Box>

          <Typography
            variant="subtitle1"
            sx={{ mt: 3, mb: 1, fontWeight: "bold" }}
          >
            الأرقام الموجودة لهذا العرض
          </Typography>

          <table className="product-table">
            <thead className="color-table">
              <tr>
                <th>#</th>
                <th>الرقم التسلسلي</th>
                <th>الحالة</th>
                <th>إجراء</th>
              </tr>
            </thead>

            <tbody>
              {offerSerials.length > 0 ? (
                offerSerials.map((serial, index) => (
                  <tr key={serial.id}>
                    <td>{index + 1}</td>
                    <td>{serial.serialNumber}</td>
                    <td>
                      {serial.isUsed ? (
                        <span style={{ color: "red", fontWeight: "bold" }}>
                          مستخدم
                        </span>
                      ) : (
                        <span style={{ color: "green", fontWeight: "bold" }}>
                          غير مستخدم
                        </span>
                      )}
                    </td>
                    <td>
                      {!serial.isUsed && (
                        <button
                          className="icon-button"
                          onClick={() => handleDeleteSerial(serial.id)}
                        >
                          <FontAwesomeIcon
                            icon={faTrash}
                            style={{ color: "red" }}
                          />
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4} style={{ textAlign: "center", padding: 15 }}>
                    لا توجد أرقام مضافة
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </Box>
      </Modal>

      {/* مودال حذف العرض */}
      <Modal open={deleteModalOpen} onClose={closeDeleteModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 420,
            bgcolor: "white",
            borderRadius: "8px",
            boxShadow: 24,
            p: 3,
            direction: "rtl",
          }}
        >
          <Typography
            variant="h6"
            component="h2"
            sx={{
              textAlign: "center",
              marginBottom: 2,
              fontFamily: "Tajawal, sans-serif",
            }}
          >
            هل أنت متأكد من أنك تريد حذف هذا العرض؟
          </Typography>

          <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
            <Button variant="contained" color="error" onClick={handleDelete}>
              نعم، احذف العرض
            </Button>

            <Button
              variant="outlined"
              color="secondary"
              onClick={closeDeleteModal}
            >
              إلغاء
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default OffersPoint;